import "./Login.css";
import React from "react";
import { images } from "../../../Assets/assetsHelper";
import LoginForm from "../../../Components/Organisms/Forms/LoginForm/LoginForm";

function Login() {
  return (
    <div className="Login">
      <div className="leftLogin">
        <img alt="Logo" className="Company_Logo" src={images.Logo} />
      </div>
      <div className="rightLogin">
        <div className="welcomeSection">
          <h1 className="welcomeTitle">Welcome Back</h1>
          <p className="welcomeSubtitle">
            Unlock your potential with Skill Code's comprehensive learning
            platform
          </p>
        </div>
        <div className="container">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export default Login;
